import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { EventType } from '@app/shared/enums/EventType.enum';

@Pipe({
    name: "eventTypePipe",
    standalone: false
})
export class EventTypePipe implements PipeTransform {
  public operationType = EventType;
  public eventTypes: any[] = [];

  constructor(public translate: TranslateService) {
  }

  transform(key: any): any {
    for (let item in this.operationType) {
      if (this.operationType[item] === key)
        return this.translate.instant('ENUMS.EVENT_TYPE_' + key);
    }
  }

  getList() {
    this.eventTypes = [];

    for (const [propertyKey, propertyValue] of Object.entries(EventType)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }

      this.eventTypes.push({id: !!propertyValue, name: this.translate.instant('ENUMS.' + propertyKey)});
    }

    return this.eventTypes;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(EventType)) {
      if (propertyValue == Id) {
        return {id: propertyValue, name: this.translate.instant('ENUMS.' + propertyKey)};
      }
    }
    return null
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(EventType)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null
  }
}
